var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyinvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2041)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_585_2041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_585_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 6.85547C12.1992 7.43797 11.727 7.91016 11.1445 7.91016C10.5621 7.91016 10.0898 7.43797 10.0898 6.85547C10.0898 6.27296 10.5621 5.80078 11.1445 5.80078C11.727 5.80078 12.1992 6.27296 12.1992 6.85547Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3633 6.85547C15.3633 6.85547 13.4745 8.96484 11.1445 8.96484C8.81459 8.96484 6.92578 6.85547 6.92578 6.85547C6.92578 6.85547 8.81459 4.74609 11.1445 4.74609C13.4745 4.74609 15.3633 6.85547 15.3633 6.85547Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 6.85547C17.4727 10.3504 14.6394 13.1836 11.1445 13.1836C7.64961 13.1836 4.81641 10.3504 4.81641 6.85547C4.81641 3.36055 7.64961 0.527344 11.1445 0.527344C14.6394 0.527344 17.4727 3.36055 17.4727 6.85547Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2406 17.251L0.749023 15.7594L4.33454 12.174L5.82604 13.6655L2.2406 17.251Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66988 11.3301L5.08008 12.9199",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyinvoices);
export default __webpack_public_path__ + "static/media/verifyinvoices.c7319017c9853d7f6327f3007bc75287.svg";
export { ForwardRef as ReactComponent };